import api from './axios';

export const withdrawalsAPI = {
  /**
   * GET /api/admin/withdrawals
   * @param {Object} params - search, status, from, to, page, per_page
   */
  getList: (params = {}) => api.get('/admin/withdrawals', { params }),

  /**
   * PUT /api/admin/withdrawals/{id}/status
   * @param {number} id
   * @param {{ status: 'approved'|'rejected', remarks?: string }} payload
   */
  updateStatus: (id, payload) => api.put(`/admin/withdrawals/${id}/status`, payload),

  /**
   * GET /api/admin/withdrawals/transfers
   * @param {Object} params - search, transfer_status, from, to, page, per_page
   */
  getTransfers: (params = {}) => api.get('/admin/withdrawals/transfers', { params }),

  /**
   * PUT /api/admin/withdrawals/{id}/transfer
   * @param {number} id
   * @param {{ transfer_method?: string, transfer_status: string, transfer_notes?: string }} payload
   */
  updateTransfer: (id, payload) => api.put(`/admin/withdrawals/${id}/transfer`, payload),
};
